<template>
  <div @click="clickToPin ? makeDefault() : null" class="address-card bg-white p-4 rounded-lg shadow-sm border relative transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
       :class="{ 'z-30': showMenu }">
    <div class="flex justify-between items-start">
      <div>
        <h3 class="font-semibold text-lg">
          {{ address.address_name || address.type }}
        </h3>
        <p class="text-gray-600 mt-1">
          {{ address.full_address }}
        </p>
      </div>
      
      <div class="relative" >
        <span v-if="address.default" class="inline-block mt-2">
          <img src="@/assets/icons/pin.svg" alt="default" class="w-15 h-15">
        </span>
        <button v-if="!hideMenu" @click="toggleMenu" class="p-1 hover:bg-gray-100 rounded">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="1" />
            <circle cx="12" cy="5" r="1" />
            <circle cx="12" cy="19" r="1" />
          </svg>
        </button>
        
        <div v-if="showMenu" class="absolute" :class="[
          $i18n.locale === 'ar' ? 'left-0' : 'right-0', 
          'mt-2 bg-white rounded-md shadow-lg z-40 border whitespace-nowrap'
        ]">
          <div class="py-1">
            <button @click="editAddress" class="w-full px-4 py-2 hover:bg-gray-100 flex items-center transition-colors duration-200" :class="[$i18n.locale === 'ar' ? 'flex-row-reverse text-right' : 'text-left']">
              {{ $t('general.edit') }}
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" :class="[$i18n.locale === 'ar' ? 'ml-2' : 'mr-2']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </button>
            <button 
              v-if="!address.default"
              @click="makeDefault" 
              class="w-full px-4 py-2 hover:bg-gray-100 flex items-center transition-colors duration-200"
              :class="[$i18n.locale === 'ar' ? 'flex-row-reverse text-right' : 'text-left']"
            >
              {{ $t('general.addresses.make_default') }}
              <img src="@/assets/icons/pin.svg" alt="star" class="w-15 h-15" :class="[$i18n.locale === 'ar' ? 'ml-2' : 'mr-2']" />
            </button>
            <button @click="deleteAddress" class="w-full px-4 py-2 hover:bg-gray-100 text-red-600 flex items-center transition-colors duration-200" :class="[$i18n.locale === 'ar' ? 'flex-row-reverse text-right' : 'text-left']">
              {{ $t('general.delete') }}
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" :class="[$i18n.locale === 'ar' ? 'ml-2' : 'mr-2']" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 6h18" />
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressCard',
  props: {
    address: {
      type: Object,
      required: true
    },
    hideMenu: {
      type: Boolean,
      default: false,
      required: false
    },
    clickToPin: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  mounted() {
    // Add click outside listener
    document.addEventListener('click', this.closeMenuOnClickOutside)
  },
  beforeDestroy() {
    // Clean up listener
    document.removeEventListener('click', this.closeMenuOnClickOutside)
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    closeMenuOnClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showMenu = false
      }
    },
    editAddress() {
      this.$emit('edit', this.address)
      this.showMenu = false
    },
    makeDefault() {
      this.$emit('make-default', this.address)
      this.showMenu = false
    },
    deleteAddress() {
      this.$emit('delete', this.address)
      this.showMenu = false
    }
  }
}
</script>

<style scoped>
.address-card {
  position: relative;
  transform-origin: center;
  backface-visibility: hidden;
  will-change: transform, box-shadow;
}

.address-card:hover {
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}
</style> 